<template>
  <p v-if="immediate && error.isError"  class="m-error-text">
    <span v-if = "only">{{error.desc}}</span>
    <!--<span else v-for="error of errors.errors">{{error}};</span>-->
  </p>
</template>

<script>
  import utils from '@/assets/utils/index'

  export default {
    props: {
      val: [String, Number, Object, Array, Boolean],
      rules: [String, Object, Array],
      immediate: {
        type: Boolean,
        default: true
      },
      only: {
        type: Boolean,
        default: true
      },
      group: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        error: {},
        initError: {}
      }
    },
    watch: {
      val () {
        this.error = utils.validate(this.val, this.rules, this.only)
      }
    },
    computed: {
      // errors () {
      //   return utils.validate(this.val, this.rules, this.only)
      // }
    },
    mounted () {
      this.error = utils.validate(this.val, this.rules, this.only)
    },
    methods: {
    }
  }
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/common/MerrorText.vue